module.exports = __webpack_public_path__ + "img/ocean_small.97fe6c27.png";